import {Helmet} from "react-helmet";
import React, { useState } from 'react';
import "./App.css";


function App() {
  const [inputValue, setInputValue] = useState('');
  const [isDivVisible, setIsDivVisible] = useState([false, false, false]);

  const checkValue = () => {
    if (inputValue.length < 6) {
      alert("El número de patente no es valido");
      return;
    }

    var userId = localStorage.getItem('userId');
    if (!userId) {
      userId = Math.random().toString();
      localStorage.setItem('userId', userId);
    }

    var visibleIndex = localStorage.getItem(userId);
    if (visibleIndex === null) {
      visibleIndex = Math.floor(Math.random() * 3);
      localStorage.setItem(userId, visibleIndex);
    } else {
      visibleIndex = parseInt(visibleIndex);
    }

    setIsDivVisible([false, false, false])

    function mostrarDiv() {
      setTimeout(function() {
        if (visibleIndex === 0) {
          setIsDivVisible([true, false, false])
        } else if (visibleIndex === 1) {
          setIsDivVisible([false, true, false])
        } else {
          setIsDivVisible([false, false, true])
        }
      }, 2000);
    }

    mostrarDiv();
  };


  return (
    <>
      <Helmet>
        <title>Consulte Infraccion</title>
      </Helmet>
      <div id="header">
        <div className="nose">
          <img src="img/logo.png" className="logo" alt="" />
        </div>
      </div>
      <div id="body">
        <p className="p1">Consultar infracciones</p>
        <p className="p2">
          Accedé a información sobre infracciones de tránsito pendientes de pago y
          tu puntaje, en la Ciudad de Buenos Aires.
        </p>
        <div className="body">
          <img src="img/aler.svg" className="alert" alt="" />
          <p className="p3">
            Recordá que podés solicitar tu constancia de libre de deuda a través de
            Boti +54 11-5050-0000
          </p>
          <br />
          <br />
          <a href="#" className="a1">
            Ir a Bot
          </a>
        </div>
        <p className="p4">Quiero datos sobre</p>
        <div className="botonizq">Una patente</div>{" "}
        <div className="botondrch">Un documento</div>
        <p className="p5">
          Visualizá si tu vehículo tiene infracciones pendientes o accedé al
          Comprobante de Libre Deuda.
        </p>
        <br />
        <br />
        <label htmlFor="">Ingresá una patente *</label>
        <br />
        <input
          type="text"
          className="texto"
          id="myInput"
          name="myInput"
          min={6}
          max={7}
          maxLength={7}
          required=""
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <p className="p6">Al escribir la patente no debe haber espacios.</p>
        <input
          type="button"
          className="btn"
          onClick={() => checkValue()}
          id="mostrar-div"
          defaultValue="Consultar"
        />
        <div className="total" id="div1" style={{display: isDivVisible[0] ? 'block' : 'none'}}>
          <p className="p8">Total adeudado</p>
          <p className="p9">
            Tenés <b>1</b> Infracciones impagas
          </p>
          <hr />
          <p className="p11">
            Estac. Lugar prohib./forma indebida/antirreglementaria
          </p>
          <p className="p12">Acta N°104009016</p>
          <img src="img/cash.png" alt="" className="cash" />
          <p className="p10">Debe pagar: $685.43</p>
          <p className="p14">
            Si pagas ahora, obtienes 50% de descuento por Pago Voluntario.
          </p>
          <br />
          <a href="https://custom-url.com" className="pagar">
            Pagar
          </a>
        </div>
        <div className="total" id="div2" style={{display: isDivVisible[1] ? 'block' : 'none'}}>
          <p className="p8">Total adeudado</p>
          <p className="p9">
            Tenés <b>1</b> Infracciones impagas
          </p>
          <hr />
          <p className="p11">
            Prohib.circular según DIA/HORA/CARAC.VEHIC (vehículos)
          </p>
          <p className="p12">Acta N°104669018</p>
          <img src="img/cash.png" alt="" className="cash" />
          <p className="p10">Debe pagar: $685.43</p>
          <p className="p14">
            Si pagas ahora, obtienes 50% de descuento por Pago Voluntario.
          </p>
          <br />
          <a href="https://custom-url.com" className="pagar">
            Pagar
          </a>
        </div>
        <div className="total" id="div3" style={{display: isDivVisible[2] ? 'block' : 'none'}}>
          <p className="p8">Total adeudado</p>
          <p className="p9">
            Tenés <b>1</b> Infracciones impagas
          </p>
          <hr />
          <p className="p11">
            Conducir utilizando Celular / Auriculares / Reproductor de video
          </p>
          <p className="p12">Acta N°104889066</p>
          <img src="img/cash.png" alt="" className="cash" />
          <p className="p10">Debe pagar: $685.43</p>
          <p className="p14">
            Si pagas ahora, obtienes 50% de descuento por Pago Voluntario.
          </p>
          <br />
          <a href="https://custom-url.com" className="pagar">
            Pagar
          </a>
        </div>
        <br />
        <br />
        <p className="p7">
          Consultá los{" "}
          <a href="#" className="a2">
            Términos y condiciones.
          </a>
        </p>
        <br />
        <br />
      </div>
    </>
  );
}

export default App;
